/**
 * PdfPreview — styled "PDF on a page" component.
 *
 * Renders a rectangular paper-shaped surface with header, body, and
 * watermark. Used for tech specs, invoices, customs paperwork. Visual
 * only — no actual PDF generation.
 */
import React from 'react';
import { FileText, Printer, Download, Share2 } from 'lucide-react';

const PdfPreview = ({ title, fileName, badge, children, watermark, actions = true }) => {
  return (
    <div className="pdf-preview">
      {actions && (
        <div className="pdf-preview-toolbar">
          <div className="pdf-preview-toolbar-left">
            <FileText size={14} />
            <span className="pdf-preview-filename">{fileName}</span>
            {badge && <span className="pdf-preview-badge">{badge}</span>}
          </div>
          <div className="pdf-preview-toolbar-right">
            <button className="pdf-preview-toolbar-btn" title="Print"><Printer size={13} /></button>
            <button className="pdf-preview-toolbar-btn" title="Download"><Download size={13} /></button>
            <button className="pdf-preview-toolbar-btn" title="Share"><Share2 size={13} /></button>
          </div>
        </div>
      )}
      <div className="pdf-preview-page">
        {watermark && <div className="pdf-preview-watermark">{watermark}</div>}
        {title && <h2 className="pdf-preview-title">{title}</h2>}
        <div className="pdf-preview-body">{children}</div>
      </div>
    </div>
  );
};

export default PdfPreview;
